<template lang="pug">
div
  header#topnav
    .topbar-main
      .container-fluid
        // Logo container
        .logo
          // Text Logo
          a.logo(href="/webp/")
            span
              i.mdi.mdi-chart-bar-stacked.m-r-5
              span ページまるごとWebP変換
              span.d-none.d-md-inline ・効果測定と一括ダウンロード
        // End Logo container
        .menu-extras.topbar-custom
          ul.list-inline.float-right.mb-0
            li.list-inline-item.dropdown.notification-list.d-inline.d-lg-none
              a.nav-link.dropdown-toggle.nav-user(data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false")
                .text-lg
                  i.mdi.mdi-menu
              .dropdown-menu.dropdown-menu-right.profile-dropdown(aria-labelledby="Preview")
                router-link(to="/" class="dropdown-item notify-item")
                  strong
                    i.mdi.mdi-arrow-right-box
                    | 新しいページをWebP変換
                router-link(to="/history/" class="dropdown-item notify-item" v-if="hasHistory")
                  i.mdi.mdi-clock
                  | 最近見たレポート
                router-link(to="/about/" class="dropdown-item notify-item")
                  i.mdi.mdi-help-circle
                  | このツールについて
                a(href="/webp-share/")
                  i.mdi.mdi-chart-pie
                  | WebP対応シェアチェッカー

          ul.list-inline.float-right.mb-0
            TasksCount
        .clearfix
      // end container
    // end topbar-main
    .navbar-custom
      .container-fluid
        #navigation
          // Navigation Menu
          ul.navigation-menu
            li
              router-link(to="/")
                .text-lg
                  i.mdi.mdi-arrow-right-box
                  | 新しいページをWebP変換
            li(v-if="hasHistory")
              router-link(to="/history/")
                i.mdi.mdi-clock
                | 最近見たレポート
            li
              router-link(to="/about/")
                i.mdi.mdi-help-circle
                | このツールについて
            li
              a(href="/webp-share/")
                i.mdi.mdi-chart-pie
                | WebP対応シェアチェッカー
 
          // End navigation menu
        // end #navigation
      // end container
    // end navbar-custom
  // End Navigation Bar

</template>

<style>
.logo {
  text-transform: none !important;
}
.profile-dropdown {
  width: auto;
}
</style>

<script>
import TasksCount from '@/components/TasksCount'
import Lib from '@/lib'

export default {
  components: {
    TasksCount
  },
  data() {
    return {
      history: [],
    }
  },
  created() {
    this.updateHistory()
    setInterval(() => this.updateHistory(), 30 * 1000)
  },
  methods: {
    updateHistory() {
      const history = new Lib.History(window.localStorage.getItem('history'))
      this.history = history.records
    }
  },
  computed: {
    hasHistory() {
      return this.history.length > 0
    }
  },
}
</script>